import api from "../../../../services/api";

// from formdata send it
const postUpdateUsers = async usersJson => {
  return await api.post("/admin/update-users", { usersJson: usersJson });
};

const postUpdateTests = async zipPath => {
  const data = new FormData();
  data.append("file", zipPath);
  return await api.post("/admin/update-tests", data);
};

const postLoadUsersFromResults = async () => {
  return await api.post("/admin/load-users-from-results", {});
};

const postTestUsersQuestions = async () => {
  return await api.post("/admin/test-users-questions", {});
};

const postDeleteResponses = async () => {
  return await api.post("/admin/delete-responses", {});
};

const postDeleteAttendedUsers = async () => {
  return await api.post("/admin/delete-attended-users", {});
};

const postDeleteSingleUser = (userID) => {
  return api.post("/admin/delete-single-user", { userID });
};

const postDeleteAllUsers = () => {
  return api.post("/admin/delete-all-users", {});
};

const postAddSingleUser = (user) => {
  return api.post("/admin/add-single-user", { user });
};

export {
  postLoadUsersFromResults,
  postTestUsersQuestions,
  postUpdateTests,
  postUpdateUsers,
  postDeleteResponses,
  postDeleteAttendedUsers,
  postDeleteSingleUser,
  postDeleteAllUsers,
  postAddSingleUser
};
